import { ALL_BRANDS_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { QueryParameters as CategoryQueryParams } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import suppliersLink, {
  QueryParameters as SupplierQueryParams,
} from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId";
import brandValueSuppliersLink from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/brand-value/brandValue";

export const getBrandValueLink = (brandValue: string) => {
  return brandValueSuppliersLink(ALL_BRANDS_URL_ID, brandValue);
};

export const getAllBrandsLink = (
  params?: Partial<CategoryQueryParams> | Partial<SupplierQueryParams>
) => {
  return suppliersLink(
    ALL_BRANDS_URL_ID,
    SupplierQueryParams.build(params as Partial<SupplierQueryParams>)
  );
};
